import { EventEmitter, Injectable } from '@angular/core';

import { SkyRepeaterItemComponent } from './repeater-item.component';


export class SkyRepeaterService {
  public itemCollapseStateChange = new EventEmitter<SkyRepeaterItemComponent>();

  public onItemCollapseStateChange(item: SkyRepeaterItemComponent) {
    this.itemCollapseStateChange.emit(item);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
